import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { SiteConfigContext } from '@jelly/components'

const FooterContainer = styled.footer`
	align-items: center;
	display: flex;
	flex-direction: column;
	background-color: ${({ theme }) => theme.colors.primary};
	justify-content: center;
	width: 100%;
`
const MainContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	padding: 4rem 1rem 3rem;
	width: 100%;

	${({ theme }) => theme.MQ.L} {
		align-items: center;
		flex-direction: row;
		${({ theme }) => theme.maxWidth.L};
	}
`
const LinksContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 2.5rem;

	${({ theme }) => theme.MQ.L} {
		align-items: center;
		flex-direction: row;
		margin-top: 0;
	}
`
const Link = styled.a`
	color: ${({ theme }) => theme.colors.white};
	font-size: 0.875rem;
	letter-spacing: 0;
	line-height: 21px;
	margin-bottom: 1.25rem;
	text-decoration: underline;
	transition: color 0.2s ease-in-out;

	&:hover {
		color: ${({ theme }) => theme.colors.secondary};
	}

	${({ theme }) => theme.MQ.L} {
		border-right: 1px solid;
		margin: 0;
		padding: 0 1rem;

		&:first-of-type {
			margin-left: 1rem;
		}

		&:last-of-type {
			border-right: none;
		}
	}
`
const FullWidthBottomContainer = styled.div`
	background-color: #002e48;
	width: 100%;
`
const CopyrightContainer = styled.div`
	align-items: center;
	color: ${({ theme }) => theme.colors.white};
	display: flex;
	font-size: 0.875rem;
	justify-content: space-between;
	margin: 0 auto;
	padding: 1rem;
	width: 100%;
	${({ theme }) => theme.maxWidth.L};

	${({ theme }) => theme.MQ.M} {
		justify-content: flex-end;
		grid-gap: 2rem;
	}
`

/**
 * Footer that just consists of the site Logo
 */
export function Footer() {
	const {
		siteComponents: { SiteLogo },
	} = useContext(SiteConfigContext)

	return (
		<FooterContainer id="footer">
			<MainContainer>
				<SiteLogo color="#FFFFFF" />

				<LinksContainer>
					<Link href="/privacy-policy/">Privacy Policy</Link>
					<Link href="/terms-of-use/">Terms of Use</Link>
					<Link href="/optout/">Do Not Sell My Personal Information</Link>
					<Link href="/accessibility/">Accessibility</Link>
				</LinksContainer>
			</MainContainer>

			<FullWidthBottomContainer>
				<CopyrightContainer>
					<span>&copy; {new Date().getFullYear()} business.com</span>
					<span>All Rights Reserved</span>
				</CopyrightContainer>
			</FullWidthBottomContainer>
		</FooterContainer>
	)
}
